import { createSelector } from '@reduxjs/toolkit';

import { CheckResult } from '@paragon/contract-library';
import { notNullish } from '@paragon/utilities';

import { getAnalysisResultRequestsForActiveAnalysisSet } from './getAnalysisResultsForActiveAnalysisSetSelector';

export interface CheckResultWithLoadCaseGuid extends CheckResult {
  readonly loadCaseGuid: string;
}

export const getCheckResultsForActiveAnalysisSet = createSelector(
  getAnalysisResultRequestsForActiveAnalysisSet,
  (analysisResultRequests): readonly CheckResultWithLoadCaseGuid[] | null => {
    if (!analysisResultRequests) return null;

    const analysisResults = analysisResultRequests
      .map((analysisResultRequest) => (analysisResultRequest?.status === 'loaded' ? analysisResultRequest.item : null))
      .filter(notNullish);
    if (analysisResultRequests.length !== analysisResults.length) return null;

    return analysisResults.flatMap((analysisResult) =>
      analysisResult.checkResults.map((checkResult) => ({ ...checkResult, loadCaseGuid: analysisResult.loadCaseGuid })),
    );
  },
);
